import { render, staticRenderFns } from "./NotificationsArea.vue?vue&type=template&id=16e85acf&scoped=true"
import script from "./NotificationsArea.vue?vue&type=script&lang=js"
export * from "./NotificationsArea.vue?vue&type=script&lang=js"
import style0 from "./NotificationsArea.vue?vue&type=style&index=0&id=16e85acf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e85acf",
  null
  
)

export default component.exports